export const DEFAULT_TITLE = 'Default Title';
export const SUBSCRIPTION_CANCELLATION_NOTE = 'Modify or cancel anytime';
